import React, {
  memo,
  forwardRef,
  useImperativeHandle,
  useRef,
  useEffect,
} from 'react';
import clsx from 'clsx';
import './Checkbox.less';

import { ReactComponent as IconEmpty } from 'assets/images/empty_checkbox.svg';
import { ReactComponent as IconChecked } from 'assets/images/checked_checkbox.svg';
import { ReactComponent as IconIndeterminate } from 'assets/images/indeterminate_checkbox.svg';

interface Props
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  indeterminate?: boolean;
}

export const Checkbox = memo(
  forwardRef<HTMLInputElement, Props>(
    ({ className, indeterminate, checked, disabled, ...props }, ref) => {
      const internalRef = useRef<HTMLInputElement>(null);
      useImperativeHandle(ref, () => internalRef.current!);

      useEffect(() => {
        if (internalRef.current) {
          internalRef.current.indeterminate = !!indeterminate;
        }
      }, [indeterminate]);

      let Icon = IconEmpty;
      if (indeterminate) {
        Icon = IconIndeterminate;
      } else if (checked) {
        Icon = IconChecked;
      }

      return (
        <label
          className={clsx('custom-checkbox', className, {
            'is-disabled': disabled,
          })}
        >
          <input
            {...props}
            type="checkbox"
            ref={internalRef}
            checked={checked}
            disabled={disabled}
            className="custom-checkbox__hidden-input"
          />

          <Icon className="custom-checkbox__icon" />

          {props.children && (
            <span className="custom-checkbox__label">{props.children}</span>
          )}
        </label>
      );
    },
  ),
);
